// extracted by mini-css-extract-plugin
export default {"patientIdSelection":"patient-id-selection_patientIdSelection__3lr5K","idEntry":"patient-id-selection_idEntry__yFZlr","selected":"patient-id-selection_selected__hXnOx"};